module.exports = __webpack_public_path__ + "static/Slate-3261bf147e5e27b3a6d450766d9d28a7.png";